import { render, staticRenderFns } from "./salary-storage-setting-dialog.vue?vue&type=template&id=b21d3d48&scoped=true&"
import script from "./salary-storage-setting-dialog.vue?vue&type=script&lang=js&"
export * from "./salary-storage-setting-dialog.vue?vue&type=script&lang=js&"
import style0 from "./salary-storage-setting-dialog.vue?vue&type=style&index=0&id=b21d3d48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21d3d48",
  null
  
)

export default component.exports